import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BUTTON, BUTTON_ICON, CLASS_MODIFIERS, ICON_BUTTON, LINK, CODE } from '../constants';
import COMPONENTS_DEFAULT_VALUES from '../constants/componentsDefaultValues';
const {
  BUTTON_TYPE,
  DEFAULT,
  DESKTOP,
  GTM_CLASS_NAME,
  HIDE,
  ICON,
  MOBILE,
  MODIFIER,
  SIZE,
  STICKY,
  STYLE,
  TABLET,
  WIDTH,
  ALIGNMENT,
  PARALLAX
} = CLASS_MODIFIERS;
const commonProps = [GTM_CLASS_NAME, MODIFIER, PARALLAX];
const responsiveProps = [DESKTOP, TABLET, MOBILE];
const buttonProps = [SIZE, BUTTON_TYPE, ICON, STYLE, ALIGNMENT, ...commonProps];
const iconProps = [BUTTON_TYPE, ...commonProps];
const commonAttributes = {
  props: commonProps,
  prefix: null
};
const supportedTypes = {
  row: {
    props: [WIDTH, STICKY, ...responsiveProps, ...commonProps]
  },
  column: {
    props: [WIDTH, STICKY, ...responsiveProps, ...commonProps]
  },
  button: {
    props: buttonProps,
    prefix: BUTTON
  },
  icon: {
    props: iconProps,
    prefix: ICON_BUTTON
  },
  textBlock: _objectSpread({}, commonAttributes),
  banner: _objectSpread({}, commonAttributes),
  image: _objectSpread({}, commonAttributes),
  hero: _objectSpread({}, commonAttributes),
  video: _objectSpread({}, commonAttributes),
  list: _objectSpread({}, commonAttributes),
  code: _objectSpread(_objectSpread({}, commonAttributes), {}, {
    prefix: CODE
  })
};
export default function getClassModifiers(type, props) {
  const {
    props: supportedProps,
    prefix
  } = supportedTypes[type] || {};
  const defaultValues = COMPONENTS_DEFAULT_VALUES[type] || {};
  if (!supportedProps) return '';
  const modifiers = supportedProps.map(prop => {
    const propValue = props[prop];
    const stringValue = typeof propValue === 'boolean' ? prop : propValue;
    const isResponsiveProp = responsiveProps.includes(prop);
    if (prop === ICON) return propValue ? BUTTON_ICON : '';
    if (prop === MODIFIER && propValue) return `${propValue}`;
    if (propValue === DEFAULT || stringValue === type) return '';
    if (isResponsiveProp) return propValue ? '' : `${HIDE}-${prop}`;
    if (propValue === null || propValue === undefined) return defaultValues[prop] || '';
    if (prop === WIDTH || prop === LINK) return `${type}--${propValue}`;
    if (prop === GTM_CLASS_NAME) return `${propValue}`;
    if (prop === STICKY) return propValue ? `${type}--${stringValue}` : '';
    if (prop === PARALLAX) return propValue ? `${type}--${stringValue}` : '';
    return stringValue ? `${type}--${stringValue}` : '';
  }).filter(Boolean);
  if (prefix) modifiers.unshift(prefix);
  return modifiers.join(' ');
}
//# sourceMappingURL=get-class-modifiers.js.map